<template>
  <div>
    <div name="header" id="header" class="obpm-header">
      <div class="table_noborder obpm-topbar d-flex">
        <div class="obpm-topbar-title pl-4">组织后台</div>
        <!-- <div class="admin-bg01"></div>
        <div class="admin-bg02"></div>
        <div class="admin-bg03"></div>
        <div class="admin-bg04"></div> -->
        <div class="obpm-topbar-info pr-4">
          <!-- <router-link class="obpm-topbar-homepage pr-2" title="主页" tabindex  to='/home'>{{$t('home')}}</router-link> -->
          <a class="obpm-topbar-logout pr-2 obpm-topbar-help" title="注销" @click="loginout">{{$t('loginout')}}</a>
          <!-- <a class="obpm-topbar-help" id="helpLink" tabindex title="帮助" @click="closeHelp">{{$t('closeHelp')}}</a> -->
        </div>
      </div>
      <el-drawer
        title="域基本信息帮助:"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">
        <div>
          <h5>当前任务描述</h5>
          <p>域信息的维护页面</p>
        </div>
        <div>
          <h5>功能说明</h5>
          <p><span>域名称：</span>设置域的名称</p>
          <p><span>状态：</span>设置域状态为激活或者不激活。若为激活，则前台可正常登录。否则无法正常登录</p>
          <p><span>描述：</span>设置域描述信息</p>
          <p><span>短信发送编码：</span>短信端口的唯一标识。需要系统发送短信到手机时使用。通常由ISP提供（如有需要可联系百保盾客服人员）</p>
          <p><span>短信发送密码：</span>通常由ISP提供（如有需要可联系百保盾客服人员）</p>
          <p><span>皮肤：</span>设置域前端登录的风格。可分为default、fresh、green、gray、blue（支持自定义）</p>
          <p><span>保存：</span>保存当前页面信息</p>
          <p><span>退出：</span>返回域列表界面</p>

        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import {getCookie, setCookie} from '../utils'
export default {
  data() {
    return {
      drawer: false,
      direction: 'rtl',
    };
  },
  
  methods:{
    closeHelp(){
      this.drawer=true;
    },
    handleClose(done) {
      done()
    },
    loginout(){
      this.$api.LogOut({
        onSucess: response => {
          if (response.data.errmsg == "ok") {
            window.sessionStorage.setItem("vuex","")
            this.$router.push("/login");
           // 重新设置为中文
            setCookie('domainLanguage', 'zh', 1)
            this.$i18n.locale = getCookie('domainLanguage')
          }else{
            this.$router.push("/login");
            // this.$message({
            //   showClose: true,
            //   message: response.data.errmsg,
            //   type: "error"
            // });
          }
        }
      });
    }
    
  },
};
</script>
